import { useState } from "react";
import { CircleAlert } from "lucide-react";
import Modal from "./Modal";

export default function ApplicationFormModal({
  application = null,
  busy = false,
  error = "",
  onSubmit,
  onClose,
}) {
  const isEdit = application !== null;
  const [title, setTitle] = useState(application?.title ?? "");
  const [path, setPath] = useState(application?.path ?? "");
  const [localError, setLocalError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setLocalError("");

    if (!title.trim()) {
      setLocalError("عنوان اپلیکیشن را وارد کنید.");
      return;
    }
    if (!path.trim().startsWith("/")) {
      setLocalError("مسیر اپلیکیشن باید از ریشه (/) شروع شود.");
      return;
    }
    onSubmit({ title: title.trim(), path: path.trim() });
  };

  const shownError = localError || error;

  return (
    <Modal
      title={isEdit ? `ویرایش «${application.title}»` : "اپلیکیشن جدید"}
      description="مسیر، محل پروژه روی سرور است."
      onClose={onClose}
      footer={
        <>
          <button type="submit" form="application-form" className="btn btn-primary" disabled={busy}>
            {busy ? "در حال ذخیره…" : "ذخیره"}
          </button>
          <button type="button" className="btn btn-ghost" onClick={onClose} disabled={busy}>
            انصراف
          </button>
        </>
      }
    >
      {shownError && (
        <div className="alert alert-error">
          <CircleAlert size={17} strokeWidth={2} aria-hidden="true" />
          {shownError}
        </div>
      )}

      <form id="application-form" onSubmit={handleSubmit} noValidate>
        <div className="field">
          <label htmlFor="application-title">عنوان</label>
          <input
            id="application-title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="مثلاً: دانشنامه"
          />
        </div>

        <div className="field">
          <label htmlFor="application-path">مسیر روی سرور</label>
          <input
            id="application-path"
            type="text"
            className="ltr-input"
            value={path}
            onChange={(e) => setPath(e.target.value)}
            placeholder="/app/code/example"
          />
          <span className="hint">مسیر مطلق، از ریشه سرور.</span>
        </div>
      </form>
    </Modal>
  );
}
